<template>
	<v-app>
		<v-toolbar color="primary" class="white--text">
			<router-link to="/" style="height:35px;">
				<img src="@/assets/img/logo.png" width="50px" style="filter: opacity(95%);">
			</router-link>

			<router-link to="/" style="text-decoration:none;" class="white--text">
				<v-toolbar-title class="ml-3">CASA NOVA <span style="color:#daa520;">{{ admin ? 'CADASTRO ADMIN' : '' }}</span></v-toolbar-title>
			</router-link>

			<v-spacer />

			<div v-if="$store.usuario">
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn
							v-if="$store.usuario"
							color="gray"
							light
							fab
							class="mr-0"
							style="width:45px;height:45px;"
							v-on="on"
						>
							<span>{{ iniciaisUsuario }}</span>
						</v-btn>
					</template>

					<v-list class="py-0">
						<v-list-tile>
							<v-list-tile-title>
								<v-icon class="mr-2">account_circle</v-icon>
								<span>{{ $store.usuario.nome }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-divider />
						<v-list-tile @click="logout()">
							<v-list-tile-title>
								<v-icon class="mr-2">logout</v-icon>
								<span>Sair</span>
							</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
		</v-toolbar>
		<v-content>
			<v-btn v-if="canReturn" class="mt-3" dark left color="pink" max-width="120" to="/">
				<v-icon>arrow_back</v-icon>
				Voltar
			</v-btn>
			<v-message :options="messageOptions" />

			<router-view />
		</v-content>

		<v-footer color="primary" class="white--text">
			<v-layout
				row
				justify-center
				class="text-uppercase"
			>
				{{ pkg.organization }} - Versão {{ pkg.version }}
			</v-layout>
		</v-footer>

		<v-loading :show="loading" message="Salvando cadastro" />
	</v-app>
</template>

<script>
	import pkg from '../../package.json';
	import VMessage from '@/components/message';
	import VLoading from '@/components/loading';
	import api from '@/services/api';

	export default {
		components: { VMessage, VLoading },

		data() {
			return {
				messageOptions: {},
				pkg: pkg,
				loading: false,
				admin: null
			};
		},

		computed: {
			iniciaisUsuario() {
				let primeira = this.$store.usuario.nome.charAt(0);

				let sobrenome = this.$store.usuario.nome
					.split(' ')
					.pop()
					.charAt(0);
				return primeira + sobrenome;
			},

			canReturn() {
				let route = this.$route.path;

				return this.$vuetify.breakpoint.mdAndUp && route !== '/' && route !== '/login' && route !== '/redefinirsenha';
			}
		},

		async created() {
			this.$store.$on('show-message', options => (this.messageOptions = options));

			let possivelCadastrar = (await api.fetchCadastro());

			this.admin = possivelCadastrar.data.cadastroModoAdmin;
		},

		methods: {
			async logout() {
				try {
					this.loading = true;

					await api.logout();

					this.$store.usuario = null;
					this.$router.push('/login');
				} catch ({ data: { message } }) {
					if (message) {
						this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
					}
				} finally {
					this.loading = false;
				}
			}
		}
	};
</script>